/**
 * Created by quikr on 7/29/16.
 */
import * as types from "../actions/actionTypes";

function actionTypeEndsInSuccess(type) {
  return type.substring(type.length - 8) == '_SUCCESS';
}
const errors = {errors: [{}]};
export default function errorReducers(state = [errors], action) {

  if (action.type == 'STORE_ERROR') {
    return [Object.assign({}, action.error)];
  }
  else if (action.type == types.DISPLAY_ERROR) {
    return [Object.assign({}, action.error)];
  }
  else if (action.type == types.NO_ERROR) {
    const error = {
      "errors": [
        {"errorMessage": "NoError"}
      ]
    };
    return [Object.assign({}, error)];
  }
  else return [...state];

}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/errorReducers.js
 **/